import { render } from "./List_Activites.vue?vue&type=template&id=510bf6e6"
import script from "./List_Activites.vue?vue&type=script&lang=js"
export * from "./List_Activites.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__